import disc from '../../images/discussion.jpg';
import analyze from '../../images/analyze.jpg';
import ai from '../../images/augmentedIntel.jpg';

export const homeObjOne = {
  id: 'about',
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Augmented Intelligence',
  headline: 'Need that extra edge to get ahead of your competition',
  description: 'Our team has years of experience in Augmented Intelligence and the development of algorithms that can aid you in your decision making.',
  buttonLabel: 'Learn More',
  imgStart: false,
  img: ai,
  alt: 'AI',
  dark: true,
  primary: true,
  darkText: false,
  linkString: '/about'
};

export const analysisInfoSection = {
  id: 'discussion',
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: 'Weekly Discussion',
  headline: 'Get weekly analysis and pointers from our fantasy experts',
  description: 'The team at cash crew will provide free content to discuss this week\'s trends and help you build your team. Check out our weekly analysis videos. Submit your teams for analysis and who knows maybe your team will be our featured on our website.',
  buttonLabel: 'Weekly Spotlight',
  imgStart: true,
  img: disc,
  alt: 'discussion',
  dark: false,
  primary: false,
  darkText: true,
  linkString: '/discussion'
};

export const performanceInfoSection = {
  id: 'reflection',
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: 'Analyze Performance',
  headline: 'Could haves and should haves. Reflect on past weeks and seasons.',
  description: 'As we improve our team building capability, we recognize the importance of reflection. This section allows users to compare their team to the top performers. Not just the top selections from other users, the absolute best!',
  buttonLabel: 'Performance Analysis',
  imgStart: true,
  img: analyze,
  alt: 'performance',
  dark: false,
  primary: false,
  darkText: true,
  linkString: '/reflection'
};


// export const homeObjTwo = {
//   id: 'discover',
//   lightBg: true,
//   lightText: false,
//   lightTextDesc: false,
//   topLine: 'Unlimited Access',
//   headline: 'Login to your account at any time',
//   description:
//     'We have you covered no matter where you are located. All you need is an internet connection and a phone or computer.',
//   buttonLabel: 'Learn More',
//   imgStart: true,
//   img: require('../../images/svg-2.svg'),
//   alt: 'Piggybank',
//   dark: false,
//   primary: false,
//   darkText: true
// };